import { Box, ListItemIcon, Typography } from "@mui/material";
import { ReactComponent as DownloadNotiIcon } from "assets/svg/noti-download.svg";
import { Button } from "react-bootstrap";
import moment from "moment";
import { useNotificationLocalStorage } from "hooks/useNotificationLocalStorage";
import { DownloadNotification } from "../types";
import { ContentBox, NotificationHeader, StyledListItem } from "./shared";

interface DataDownloadItemProps {
    notification: DownloadNotification;
    organizationsMap: Map<string, string>;
}
export const DataDownloadAlert = ({
    notification,
    organizationsMap,
}: DataDownloadItemProps) => {
    const { isNotificationRead } = useNotificationLocalStorage();
    const formattedRequestedDate = (moment.unix(notification.time)
    )
        .utc()
        .format("MMMM D, YYYY");

    const isEmpty = notification.title.toLowerCase().includes("data is empty");

    return (
        <StyledListItem
            alignItems="flex-start"
            className={isNotificationRead(notification.id) ? "read" : "unread"}
        >
            <ListItemIcon>
                <DownloadNotiIcon />
            </ListItemIcon>
            <Box
                sx={{
                    display: "flex",
                    flexDirection: "column",
                    gap: 1,
                    width: "100%",
                }}
            >
                <NotificationHeader
                    title={notification.title}
                    orgName={
                        organizationsMap.get(notification.orgId) ||
                        notification.orgId
                    }
                    timestamp={notification.time}
                    type="Data Download Requests"
                />

                {isEmpty ? (
                    <ContentBox>
                        <Typography variant="caption" color="#828fab">
                            {`Sorry, no data to download as per your recent request (on ${formattedRequestedDate} (UTC)) for a copy of your IoTPortal data.`}
                        </Typography>
                    </ContentBox>
                ) : (
                    <ContentBox>
                        <Typography variant="caption" color="#828fab">
                            {`The copy of your data requested on ${formattedRequestedDate} (UTC)
                        is now ready for download. Please note that the download
                        link will expire on ${notification.info.expiryTime} (UTC).`}
                        </Typography>
                        <Typography variant="caption" color="#828fab">
                            <br />
                            {`Password: ${notification.info.password}`}
                        </Typography>
                    </ContentBox>
                )}

                {!isEmpty && (
                    <Button
                        style={{ width: "fit-content", marginTop: "11px" }}
                        variant="primary"
                        href={notification.info.downloadLink}
                        target="_blank"
                        rel="noopener noreferrer"
                        as="a"
                    >
                        Download Data
                    </Button>
                )}
            </Box>
        </StyledListItem>
    );
};
